export const DisclosureArrow = () => {
    return <svg className="disclosure-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M6 9l6 6 6-6"/>
    </svg>;
}
